import { useCallback } from "react";
import { useAppDispatch } from "../../app";
import { setLoadingAnnotations } from "../store/annotationSlice";

// Shows/hides a loading spinner on the given annotations. The loading state
// lives in the store (off the annotation objects) so document rebuilds during
// the task can't reset it.
const useAnnotationLoading = () => {
  const dispatch = useAppDispatch();

  const setLoading = useCallback(
    (annotationIds: Array<string>, isLoading: boolean) => {
      dispatch(setLoadingAnnotations({ ids: annotationIds, isLoading }));
    },
    [dispatch],
  );

  return { setLoading };
};

export default useAnnotationLoading;
